
import common from '@/store/common'
import { isApiH5 } from '../utils'

export default {
  async inserted (el, _binding, _vnode) {
    if (!isApiH5()) return
    const { success, data } = await common.actions.rosewalletConfig()
    if (success && data?.jumpTmdHomeFloatViewShow === 'N') {
      el.parentNode.removeChild(el)
    }
  }
}

